import createReactComponent from '../createReactComponent';
var ChevronsRight = createReactComponent('ChevronsRight', [['polyline', {
  points: '13 17 18 12 13 7',
  key: 'oq0h83'
}], ['polyline', {
  points: '6 17 11 12 6 7',
  key: '3k300q'
}]]);
export default ChevronsRight;